import { render } from "./AllGoals.vue?vue&type=template&id=543755e8&scoped=true"
import script from "./AllGoals.vue?vue&type=script&lang=js"
export * from "./AllGoals.vue?vue&type=script&lang=js"

import "./AllGoals.vue?vue&type=style&index=0&id=543755e8&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543755e8"]])

export default __exports__